"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRemoteData = exports.onSuccessUpdateRemoteDataWithArgs = exports.pendingRemoteDataToError = exports.pendingRemoteDataToSuccess = exports.matchWithReload = exports.shouldInitializeRd = exports.fetchDataWithInputalidation = exports.getArgs = exports.matchWithArgs = exports.foldWithArgs = exports.SuccessWithArgs = exports.FailureWithArgs = exports.PendingWithArgs = exports.onSuccessUpdateRemoteData = exports.zip = exports.useRemoteDataArray = exports.fromOption = exports.toOption = exports.fromEither = exports.isSuccess = exports.isFailure = exports.isPending = exports.isInitialized = exports.unwrap = exports.succeed = exports.withDefault = exports.map3 = exports.map2 = exports.andMap = exports.mapBoth = exports.mapError = exports.map = exports.orElse = exports.andThen = exports.equals = exports.match = exports.fold = exports.Success = exports.Failure = exports.Pending = exports.Initialized = exports.Kinds = void 0;
const Option_1 = require("fp-ts/Option");
const Either_1 = require("fp-ts/Either");
const function_1 = require("fp-ts/function");
var Kinds;
(function (Kinds) {
    Kinds["Initialized"] = "Initialized";
    Kinds["Pending"] = "Pending";
    Kinds["Failure"] = "Failure";
    Kinds["Success"] = "Success";
    Kinds["_"] = "_";
})(Kinds = exports.Kinds || (exports.Kinds = {}));
class Initialized {
    constructor() {
        this.kind = Kinds.Initialized;
    }
}
exports.Initialized = Initialized;
class Pending {
    constructor() {
        this.kind = Kinds.Pending;
    }
}
exports.Pending = Pending;
class Failure {
    constructor(error) {
        this.error = error;
        this.kind = Kinds.Failure;
        if (error === null || error === undefined) {
            throw new TypeError('Parameter "error" is required');
        }
    }
}
exports.Failure = Failure;
class Success {
    constructor(data) {
        this.data = data;
        this.kind = Kinds.Success;
        if (data === null || data === undefined) {
            throw new TypeError('Parameter "data" is required');
        }
    }
}
exports.Success = Success;
function fold(initialized, pending, failure, success) {
    return (state) => {
        switch (state.kind) {
            case Kinds.Initialized:
                return initialized();
            case Kinds.Pending:
                return pending();
            case Kinds.Failure:
                return failure(state.error);
            case Kinds.Success:
                return success(state.data);
            default:
                throw new NeverError(state);
        }
    };
}
exports.fold = fold;
const isComplete = (matcher) => {
    return (matcher[Kinds.Initialized] !== undefined &&
        matcher[Kinds.Pending] !== undefined &&
        matcher[Kinds.Failure] !== undefined &&
        matcher[Kinds.Success] !== undefined);
};
exports.match = (rd, matcher) => {
    if (isComplete(matcher)) {
        return fold(matcher[Kinds.Initialized], matcher[Kinds.Pending], matcher[Kinds.Failure], matcher[Kinds.Success])(rd);
    }
    switch (rd.kind) {
        case Kinds.Initialized:
            const initialized = matcher[rd.kind];
            if (initialized !== undefined) {
                return initialized();
            }
            else {
                return matcher[Kinds._]();
            }
        case Kinds.Pending:
            const pending = matcher[rd.kind];
            if (pending !== undefined) {
                return pending();
            }
            else {
                return matcher[Kinds._]();
            }
        case Kinds.Failure:
            const failure = matcher[rd.kind];
            if (failure !== undefined) {
                return failure(rd.error);
            }
            else {
                return matcher[Kinds._]();
            }
        case Kinds.Success:
            const success = matcher[rd.kind];
            if (success !== undefined) {
                return success(rd.data);
            }
            else {
                return matcher[Kinds._]();
            }
        default:
            throw new NeverError(rd);
    }
};
class NeverError extends Error {
    constructor(value) {
        super(`Unknown RemoteData state: ${value}`);
    }
}
exports.equals = (rd1, rd2) => {
    return exports.match(rd1, {
        Initialized: () => exports.match(rd2, { Initialized: () => true, _: () => false }),
        Pending: () => exports.match(rd2, { Pending: () => true, _: () => false }),
        Success: (d1) => exports.match(rd2, { Success: (d2) => d1 === d2, _: () => false }),
        Failure: (e1) => exports.match(rd2, { Failure: (e2) => e1 === e2, _: () => false }),
    });
};
/**
 * Chain together remote data function calls
 */
exports.andThen = (f, rd) => {
    return exports.match(rd, {
        Success: (d) => f(d),
        Initialized: () => new Initialized(),
        Pending: () => new Pending(),
        Failure: (e) => new Failure(e),
    });
};
/**
 * Chain together remote data function calls
 */
exports.orElse = (f, rd) => {
    return exports.match(rd, {
        Success: (d) => new Success(d),
        Initialized: () => new Initialized(),
        Pending: () => new Pending(),
        Failure: (e) => f(e),
    });
};
/**
 * Map a function into the success value
 */
exports.map = (f, rd) => {
    return exports.andThen((d) => new Success(f(d)), rd);
};
/**
 * Map a function into the error value
 */
exports.mapError = (f, rd) => {
    return exports.orElse((e) => new Failure(f(e)), rd);
};
/**
 * Map either the success function or the failure function
 * the success value or the failure value
 */
exports.mapBoth = (successFn, errorFn, rd) => {
    return exports.mapError(errorFn, exports.map(successFn, rd));
};
/**
 * Put the results of two RemoteData calls together
 */
exports.andMap = (rd1, rd2) => {
    return exports.match(rd2, {
        Initialized: () => new Initialized(),
        Pending: () => new Pending(),
        Success: (f) => exports.map(f, rd1),
        Failure: (e) => new Failure(e),
    });
};
/**
 * Combine two remote data sources with the given function. The result will succeed when (and if) both sources succeed.
 */
exports.map2 = (f, rd1, rd2) => {
    return exports.andMap(rd2, exports.map(f, rd1));
};
/**
 * Combine three remote data sources with the given function. The result will succeed when(and if) all three sources succeed. If you need`map4`, `map5`, etc, see the documentation for `andMap`.
 */
exports.map3 = (f, rd1, rd2, rd3) => {
    return exports.andMap(rd3, exports.andMap(rd2, exports.map(f, rd1)));
};
/**
 * get the success value or a default
 */
exports.withDefault = (defaultVal, rd) => {
    return exports.match(rd, {
        Success: (d) => d,
        _: () => defaultVal,
    });
};
/**
 * Lift an ordinary value into the realm of RemoteData.
 * Category theory points: This is `pure`.
 */
exports.succeed = (value) => {
    return new Success(value);
};
/**
 * Take a default value, a function and a `RemoteData`. Return the default value if the `RemoteData` is something other than `Success a`. If the `RemoteData` is `Success a`, apply the function on `a` and return the `b`.
 */
exports.unwrap = (defaultVal, f, rd) => {
    return exports.match(rd, {
        Success: (d) => f(d),
        _: () => defaultVal,
    });
};
/**
 * State-checking predicate. Returns true if we haven't asked for data yet.
 */
exports.isInitialized = (rd) => {
    return rd.kind === Kinds.Initialized;
};
/**
 * State-checking predicate. Returns true if we're loading.
 */
exports.isPending = (rd) => {
    return rd.kind === Kinds.Pending;
};
/**
 * State-checking predicate. Returns true if we've failed to load some data.
 */
exports.isFailure = (rd) => {
    return rd.kind === Kinds.Failure;
};
/**
 * State-checking predicate. Returns true if we've successfully loaded some data.
 */
exports.isSuccess = (rd) => {
    return rd.kind === Kinds.Success;
};
/**
 * Convert a Either to a RemoteData value.
 */
exports.fromEither = (either) => {
    return function_1.pipe(either, Either_1.match((l) => new Failure(l), (r) => new Success(r)));
};
/**
 * Convert a RemoteData e d to a Option d
 */
exports.toOption = (rd) => {
    return exports.match(rd, {
        Success: (d) => Option_1.some(d),
        _: () => Option_1.none,
    });
};
/**
 * Convert a Option d to a RemoteData value.
 */
exports.fromOption = (e, option) => {
    return function_1.pipe(option, Option_1.match(() => new Failure(e), (r) => new Success(r)));
};
exports.useRemoteDataArray = (rd) => {
    return exports.match(rd, {
        Success: (val) => {
            return val;
        },
        _: () => {
            return [];
        },
    });
};
exports.zip = (rd1, rd2) => {
    return exports.match(rd1, {
        Failure: (e1) => new Failure(e1),
        Success: (data1) => exports.match(rd2, {
            Failure: (e2) => new Failure(e2),
            Initialized: () => new Initialized(),
            Pending: () => new Pending(),
            Success: (data2) => new Success([data1, data2]),
        }),
        Initialized: () => exports.match(rd2, {
            Failure: (e2) => new Failure(e2),
            _: () => new Initialized(),
        }),
        Pending: () => exports.match(rd2, {
            Failure: (e2) => new Failure(e2),
            Initialized: () => new Initialized(),
            _: () => new Pending(),
        }),
    });
};
/**
 * @name onSuccessUpdateRemoteData
 * @param rd - the remote data
 * @param onSuccess - function to update remote data on success
 * @returns Success Remote Data
 * @description update a success remote data
 */
exports.onSuccessUpdateRemoteData = (rd, onSuccess) => {
    return exports.match(rd, {
        _: () => rd,
        Success: (data) => new Success(onSuccess(data)),
    });
};
class PendingWithArgs extends Pending {
    constructor(arg) {
        super();
        this.arg = arg;
    }
    toSuccess(payload) {
        return new SuccessWithArgs(payload, this.arg);
    }
    toError(error) {
        return new FailureWithArgs(error, this.arg);
    }
}
exports.PendingWithArgs = PendingWithArgs;
class FailureWithArgs extends Failure {
    constructor(error, arg) {
        super(error);
        this.error = error;
        this.arg = arg;
    }
}
exports.FailureWithArgs = FailureWithArgs;
class SuccessWithArgs extends Success {
    constructor(data, arg) {
        super(data);
        this.data = data;
        this.arg = arg;
    }
}
exports.SuccessWithArgs = SuccessWithArgs;
const isCompleteWithArgs = (matcher) => {
    return (matcher[Kinds.Initialized] !== undefined &&
        matcher[Kinds.Pending] !== undefined &&
        matcher[Kinds.Failure] !== undefined &&
        matcher[Kinds.Success] !== undefined);
};
/**
 *
 * @name foldWithArgs
 * @param initialized
 * @param pending
 * @param failure
 * @param success
 * @description Fold the RemoteDataWithArgs
 */
function foldWithArgs(initialized, pending, failure, success) {
    return (state) => {
        switch (state.kind) {
            case Kinds.Initialized:
                return initialized();
            case Kinds.Pending:
                return pending(state.arg);
            case Kinds.Failure:
                return failure(state.error, state.arg);
            default:
                return success(state.data, state.arg);
        }
    };
}
exports.foldWithArgs = foldWithArgs;
/**
 *
 * @name matchWithArgs
 * @param rd
 * @param matcher
 * @returns calls matched function with the arguments of remoteData
 */
exports.matchWithArgs = (rd, matcher) => {
    if (isCompleteWithArgs(matcher)) {
        return foldWithArgs(matcher[Kinds.Initialized], matcher[Kinds.Pending], matcher[Kinds.Failure], matcher[Kinds.Success])(rd);
    }
    switch (rd.kind) {
        case Kinds.Initialized:
            const initialized = matcher[rd.kind];
            if (initialized !== undefined) {
                return initialized();
            }
            else {
                return matcher[Kinds._]();
            }
        case Kinds.Pending:
            const pending = matcher[rd.kind];
            if (pending !== undefined) {
                return pending(rd.arg);
            }
            else {
                return matcher[Kinds._]();
            }
        case Kinds.Failure:
            const failure = matcher[rd.kind];
            if (failure !== undefined) {
                return failure(rd.error, rd.arg);
            }
            else {
                return matcher[Kinds._]();
            }
        default:
            const success = matcher[rd.kind];
            if (success !== undefined) {
                return success(rd.data, rd.arg);
            }
            else {
                return matcher[Kinds._]();
            }
    }
};
/**
 *
 * @namegetArgs
 * @param rd
 * @returns Option<A>
 * @description Gets the arguments out of a RemoteDataWithArgs
 */
exports.getArgs = (rd) => {
    return exports.matchWithArgs(rd, {
        _: () => Option_1.none,
        Success: (_data, arg) => Option_1.some(arg),
        Pending: (arg) => Option_1.some(arg),
        Failure: (_error, arg) => Option_1.some(arg),
    });
};
/**
 *
 * @name fetchDataWithInputalidation
 * @param rd
 * @param input
 * @param isNewInput
 * @param fetchData
 * @returns void
 * @description given a remote data calls fetchData if in initialized, or if the isNewInput function declared returns true
 */
exports.fetchDataWithInputalidation = (rd, input, isNewInput, fetchData) => {
    const currentArgs = exports.getArgs(rd);
    if (Option_1.isNone(currentArgs)) {
        return fetchData(input);
    }
    if (isNewInput(currentArgs.value, input)) {
        return fetchData(input);
    }
};
/**
 * @name shouldInitializeRd
 * @param rd - remote data
 * @param input - the input
 * @param isNewInput - function to determine if new input
 * @returns
 */
exports.shouldInitializeRd = (rd, input, isNewInput) => {
    const currentArgs = exports.getArgs(rd);
    if (Option_1.isNone(currentArgs)) {
        return true;
    }
    if (isNewInput(currentArgs.value, input)) {
        return true;
    }
    return false;
};
/**
 * @name matchWithReload
 * @param rd - the remote data
 * @param matcher - matcher
 * @param input - input to fetch with
 * @param isNewInput - function to re validate data fetches
 * @returns
 */
exports.matchWithReload = (rd, matcher, input, isNewInput) => {
    const rdValidated = exports.shouldInitializeRd(rd, input, isNewInput)
        ? new Initialized()
        : rd;
    return exports.matchWithArgs(rdValidated, {
        ...matcher,
        Initialized: () => {
            return matcher.Initialized(input);
        },
    });
};
/**
 * @name foldPending
 * @param rd - the remote data
 * @param notPending - function to execute when not pending
 * @param pending - function to execute on pending
 * @returns
 */
const foldPending = (rd, notPending, pending) => {
    if (exports.isPending(rd)) {
        return pending(rd);
    }
    return notPending();
};
/**
 * @name pendingRemoteDataToSuccess
 * @param rd - the remote data
 * @param payload - payload of a success
 * @returns Success Remote
 * @description convert a pending remote data to a success
 */
exports.pendingRemoteDataToSuccess = (rd, payload) => {
    return foldPending(rd, () => rd, (pending) => pending.toSuccess(payload));
};
/**
 * @name pendingRemoteDataToError
 * @param rd - the remote data
 * @param error - payload of a error
 * @returns Failure Remote
 * @description convert a pending remote data to a failure
 */
exports.pendingRemoteDataToError = (rd, error) => {
    return foldPending(rd, () => rd, (pending) => pending.toError(error));
};
/**
 * @name onSuccessUpdateRemoteDataWithArgs
 * @param rd - the remote data
 * @param onSuccess - function to update remote data on success
 * @returns Success Remote Data
 * @description update a success remote data
 */
exports.onSuccessUpdateRemoteDataWithArgs = (rd, onSuccess) => {
    return exports.matchWithArgs(rd, {
        _: () => rd,
        Success: (data, args) => new SuccessWithArgs(onSuccess(data, args), args),
    });
};
/**
 * @name isRemoteData
 * @param val - unknown
 * @returns Type Check on if is RemoteData
 */
exports.isRemoteData = (val) => {
    return (val instanceof Initialized ||
        val instanceof Pending ||
        val instanceof Success ||
        val instanceof Failure ||
        val instanceof PendingWithArgs ||
        val instanceof SuccessWithArgs ||
        val instanceof FailureWithArgs);
};
//# sourceMappingURL=RemoteData.js.map